<template>
  <v-card class="pb-4 pt-4">
    <v-card-text>
      <v-row wrap justify="center">
        <v-col cols="auto">
          <v-icon large class="icon">mdi-information-outline</v-icon>
        </v-col>
        <v-col cols="12" class="text-center my-2">
          <p class="ffP fs18 fcT2 mb-0">{{$t('compDetails.anonymInfo1')}}</p>
          <p class="ffP fs16 fcT240 my-2">{{$t('compDetails.anonymInfo2')}}</p>
          <p class="ffP fs16 fcT2 mb-1">{{$t('compDetails.anonymInfo3') }} <b>{{pAnonymInfo.auxId}}</b></p>
          <p class="ffP fs16 fcT2 my-1">{{$t('compDetails.anonymInfo4')}} <b>{{pAnonymInfo.password}}</b></p>             
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-center pb-3">
      <v-btn class="datPrimaryBtn mr-2" depressed @click="fClose">{{$t('datBtn.accept')}}</v-btn>
      <v-btn depressed class="datPrimaryBtn mr-2" @click="fDownloadInfoFile">{{$t('labels.download')}}</v-btn>  
    </v-card-actions>
  </v-card>
</template>

<script>

import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

export default {

  mixins: [mxCanalDenuncias],  

  props:{
    pAnonymInfo:{
      type: Object,
      required: true
    },    
  },

  methods: {
    // Cierra la modal
    fClose(){
      this.$emit('close')
    },

    // LLama a la función que descaga el fichero desde el componente padre
    fDownloadInfoFile(){
      this.$emit('info-file')
    }
  }
}
</script>

 